import { z } from "zod";

import { UnknownDocumentType } from "@/src/models/constants/document-types";
import { DatabaseDefaults } from "@/src/models/database-defaults";
import { Patient, patientMinimalSchema } from "@/src/models/patient";

export const unknownTypeDisplay: Record<UnknownDocumentType, string> = {
  [UnknownDocumentType.UNKNOWN]: "Unknown",
};

export const unknownSchema = z.object({
  patient: patientMinimalSchema,
});

export type Unknown = Omit<z.infer<typeof unknownSchema>, "patient"> & {
  patient: Patient | null;
} & DatabaseDefaults;

export const unknownShape: Unknown = {
  id: "",
  patient: null,
  createdAt: "",
  updatedAt: "",
  deletedAt: null,
  groupId: "",
};
